import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { Autocomplete, CollapseCard } from '@totalsoft/rocket-ui';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useTranslation } from 'react-i18next';
import { get, sequence } from '@totalsoft/change-tracking-react';
import { emptyArray, emptyString } from 'constants/defaultValues';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const CoefficientsComponent = ({ quotation, onCoefficientsSelectionChange, cardIconColor, disabled, allowEmptySelection, validation }) => {
  const { t } = useTranslation();

  const getSelectedCoefficientDetail = details => {
    const value = (details |> sequence).find(detail => {
      return (detail.selected |> get) === true;
    })?.detailId;
    return value ? value |> get : emptyString;
  };

  return (
    <CollapseCard
      iconColor={cardIconColor}
      icon={PlaylistAddCheckIcon}
      title={t('Offer.Edit.Casco.Coefficients.Title')}
      toggleOnHeaderClick
    >
      <Grid container spacing={2}>
        {(quotation?.coefficients |> sequence)?.length > 0 ? (
          (quotation?.coefficients |> sequence).map((coefficient, index) => (
            <Grid item xs={12} key={index}>
              {coefficient.allowMultipleDetails |> get ? (
                <Autocomplete
                  isMultiSelection
                  fullWidth
                  options={(coefficient.details |> get) || emptyArray}
                  label={coefficient.additionalDataName |> get}
                  disabled={disabled}
                  readOnly={disabled}
                  simpleValue
                  isSearchable
                  valueKey='detailId'
                  labelKey='detailName'
                  onChange={selectedCoefficients =>
                    onCoefficientsSelectionChange(selectedCoefficients, coefficient.additionalDataTypeId |> get)
                  }
                  value={(coefficient.details |> sequence)
                    .filter(detail => (detail.selected |> get) === true)
                    .map(selectedDetail => selectedDetail.detailId |> get)}
                  error={!isValid(validation.coefficients[index].details)}
                  helperText={getErrors(validation.coefficients[index].details)}
                />
              ) : (
                <Autocomplete
                  fullWidth
                  options={(coefficient.details |> get) || emptyArray}
                  label={coefficient.additionalDataName |> get}
                  disabled={disabled}
                  simpleValue
                  isSearchable
                  isClearable={allowEmptySelection}
                  valueKey='detailId'
                  labelKey='detailName'
                  onChange={selectedCoefficient =>
                    onCoefficientsSelectionChange(selectedCoefficient, coefficient.additionalDataTypeId |> get)
                  }
                  value={getSelectedCoefficientDetail(coefficient.details)}
                />
              )}
            </Grid>
          ))
        ) : (
          <Grid container justifyContent='center'>
            {t('Offer.Edit.Casco.Coefficients.EmptyList')}
          </Grid>
        )}
      </Grid>
    </CollapseCard>
  );
};

CoefficientsComponent.propTypes = {
  quotation: PropTypes.object,
  onCoefficientsSelectionChange: PropTypes.func,
  onDeleteCoefficientSelection: PropTypes.func,
  cardIconColor: PropTypes.string,
  disabled: PropTypes.bool,
  allowEmptySelection: PropTypes.bool,
  validation: PropTypes.object
};

export default CoefficientsComponent;
